import { render, staticRenderFns } from "./estatisticas-analistas.vue?vue&type=template&id=9ffd5a42"
import script from "./estatisticas-analistas.vue?vue&type=script&lang=js"
export * from "./estatisticas-analistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports